import { cn } from "@/lib/utils";

/**
 * Enterprise "System Scan" skeleton animation
 * Uses horizontal scan line instead of generic shimmer
 */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "rounded-sm bg-muted/40 relative overflow-hidden",
        "after:absolute after:inset-0 after:w-full",
        "after:bg-gradient-to-r after:from-transparent after:via-muted-foreground/5 after:to-transparent",
        "after:animate-[system-scan_2s_ease-in-out_infinite]",
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
